import React from "react";
import type { SupTransactionType } from "@/types";

import { SupText } from "@repo/core-ui";
import ResourcesEmptyBag from "@/utils/resources/emptyBag";

export default function Web3CommonCartEmpty({ type = "deposit" }: { type?: SupTransactionType }) {
  return (
    <div className="flex h-full w-full select-none flex-col items-center justify-center">
      <ResourcesEmptyBag className="h-1/2 w-full text-neutral-300" />
      <SupText variant="subtitle2" family="sans" weight="bold" className="text-neutral-300">
        YOUR {type} BAG IS EMPTY
      </SupText>
    </div>
  );
}
